import { Button, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Select, TextField } from '@mui/material';
import React, { useState, useEffect } from "react";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import axios from 'axios';
import { bankaccount, payment, reservation } from '../../../components/Apis';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { Container, MenuItem, FormControl, InputLabel } from "@mui/material";

const rows = [
    {
        unitName: "Villa Sahel",
        ownerName: "Mariam Ahmed",
        ownerImage: "https://via.placeholder.com/40", // صورة placeholder
        status: "Approved",
        date: "12/3/2024",
        Amount: "3000$",
        Servicesfee: "1000$"
    },
    {
        unitName: "Villa Sahel",
        ownerName: "Mariam Ahmed",
        ownerImage: "https://via.placeholder.com/40",
        status: "Pending",
        date: "12/3/2024",
        Amount: "3000$",
        Servicesfee: "1000$"
    },
    {
        unitName: "Villa Sahel",
        ownerName: "Mariam Ahmed",
        ownerImage: "https://via.placeholder.com/40",
        status: "Canceled",
        date: "12/3/2024",
        Amount: "3000$",
        Servicesfee: "1000$"

    },
];

const Reservation = () => {
    const [reservations, setReservations] = useState([]);
    const [bookings, setBookings] = useState([]);
    const token = localStorage.getItem("token");

    // const clientNames = reservations.booked_units?.flatMap(unit => 
    //     unit.bookings?.map(booking => booking.client_name) || ""
    //   ) || "";

    // const clientPayment = reservations.booked_units?.flatMap(unit => 
    //     unit.bookings?.map(booking => booking.payment) || ""
    //   ) || "";


    console.log("reservations", bookings)



    useEffect(() => {
        const fetchReservations = async () => {
            const response = await reservation();
            setReservations(response);
        };
        if (token) fetchReservations();
    }, [token]);

    useEffect(() => {
        reservations.booked_units?.map(unit => {
            unit.bookings?.map(booking => {
                setBookings(booking)
            })
        })
    }, [reservations])

    return (
        <div style={{ backgroundColor: "var(--seco-col)", height: "100vh", paddingTop: "2rem" }}>

            <p style={{ textAlign: "left", fontSize: "20px",marginLeft:"1rem",marginBottom:"4rem",fontWeight:"600" }}>Booked Units</p>
            <Grid item xs={12} md={12} sx={{ marginInline: "40px", backgroundColor: "var(--sec-col)" }}>
                <TableContainer sx={{ marginTop: "20px" }} component={Paper} dir="ltr">
                    <Table dir="ltr">
                        <TableHead sx={{ backgroundColor: "#F2F4F7" }}>
                            <TableRow>
                                <TableCell style={{ textAlign: "center" }}>Unit Name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Client Name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Unit Fees</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Payment</TableCell>
                                {/* <TableCell style={{ textAlign: "center" }}>Unit Name</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reservations.booked_units?.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell style={{ textAlign: "center" }}>{row.unit_name}</TableCell>

                                    <TableCell style={{ textAlign: "center" }}>{bookings.client_name}</TableCell>

                                    <TableCell style={{ textAlign: "center" }}>{row.unit_fees}</TableCell>

                                    <TableCell style={{ textAlign: "center" }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {bookings.payment}
                                        </div>
                                    </TableCell>
                                    {/* <TableCell style={{ textAlign: "center" }}>{row.unitName}</TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TableContainer sx={{ marginTop: "20px" }} component={Paper} dir="ltr">
                    <p style={{ textAlign: "left", marginLeft: "20px" }}>Last Transaction ( Owner )</p>

                    <Table>
                        <TableHead sx={{ backgroundColor: "#F2F4F7" }}>
                            <TableRow>
                                <TableCell width="25%" align="center">Total unit Revenue</TableCell>
                                <TableCell width="25%" align="center">Total Owner Revenue</TableCell>
                                <TableCell width="25%" align="center">Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align="center">{reservations.total_units_revenue}</TableCell>
                                <TableCell align="center">{reservations.total_owner_revenue}</TableCell>
                                <TableCell align="center">
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {reservations.balance}
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>


            </Grid>
        </div>
    );
}

export default Reservation;
